import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { NgIf } from "@angular/common";

@Component({
    selector: "app-empty-state",
    standalone: true,
    imports: [NgIf],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./empty-state.component.html",
    styleUrl: "./empty-state.component.scss",
})
export class EmptyStateComponent {
    @Input() icon = "event_busy";
    @Input({ required: true }) title!: string;
    @Input() message?: string;
}
